<template>
  <div>
    <v-icon :color="color_code"> mdi-checkbox-blank </v-icon>
  </div>
</template>
<script>
export default {
  props: {
    color_code: {
      type: String,
      require: true,
      default: "#FFFFFF",
    },
  },
};
</script>
